import {
  LayoutDashboard,
  BarChart3,
  Users,
  Tags,
  Tag,
  Image as ImageIcon,
  Package,
  Boxes,
  Contact,
  Receipt,
  History,
  Settings,
  type LucideIcon,
} from 'lucide-react'
import type { Role } from '@/types'

export interface NavItem {
  label: string | ((role: Role) => string)
  path: string
  /** Base path used to resolve the page title when it differs from the sidebar link target (e.g. "Ventas" links straight to /nueva). */
  titlePath?: string
  /** Coincidencia exacta de ruta: evita que, p. ej., "/admin/ventas" quede resaltado al estar en "/admin/ventas/nueva". */
  end?: boolean
  icon: LucideIcon
  /** Clase de color del ícono (p. ej. "text-emerald-500"), fija para distinguir cada sección de un vistazo. */
  color: string
  roles: Role[]
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/admin', icon: LayoutDashboard, color: 'text-violet-500', roles: ['admin'] },
  {
    label: (role) => (role === 'seller' ? 'Mis ventas' : 'Ventas'),
    path: '/admin/ventas/nueva',
    icon: Receipt,
    color: 'text-emerald-500',
    roles: ['admin', 'seller'],
  },
  {
    label: 'Historial de ventas',
    path: '/admin/ventas',
    end: true,
    icon: History,
    color: 'text-sky-500',
    roles: ['admin', 'seller'],
  },
  { label: 'Métricas', path: '/admin/metricas', icon: BarChart3, color: 'text-fuchsia-500', roles: ['admin'] },
  { label: 'Productos', path: '/admin/productos', icon: Package, color: 'text-orange-500', roles: ['admin', 'seller'] },
  { label: 'Inventario', path: '/admin/inventario', icon: Boxes, color: 'text-amber-500', roles: ['admin', 'seller'] },
  { label: 'Clientes', path: '/admin/clientes', icon: Contact, color: 'text-cyan-500', roles: ['admin', 'seller'] },
  { label: 'Vendedoras', path: '/admin/vendedoras', icon: Users, color: 'text-pink-500', roles: ['admin'] },
  { label: 'Categorías', path: '/admin/categorias', icon: Tags, color: 'text-teal-500', roles: ['admin'] },
  { label: 'Etiquetas', path: '/admin/etiquetas', icon: Tag, color: 'text-rose-500', roles: ['admin'] },
  { label: 'Banners', path: '/admin/banners', icon: ImageIcon, color: 'text-indigo-500', roles: ['admin'] },
  { label: 'Configuración', path: '/admin/configuracion', icon: Settings, color: 'text-slate-400', roles: ['admin', 'seller'] },
]

export function resolveNavLabel(item: NavItem, role: Role): string {
  return typeof item.label === 'function' ? item.label(role) : item.label
}

export function navItemsForRole(role: Role): NavItem[] {
  return NAV_ITEMS.filter((item) => item.roles.includes(role))
}
